export const messages = {
  en: {
    shopVipUserAccount: {
      title: 'Account',
      accountId: 'Account ID',
      accountName: 'Account Name',
      accountType: 'Account Type',
      accountAmount: 'Account Amount',
      createTime: 'Create Time',
      back: 'Back'
    }
  },
  zh: {
    shopVipUserAccount: {
      title: '账户',
      accountId: '账户编号',
      accountName: '账户名称',
      accountType: '账户类型',
      accountAmount: '账户金额',
      createTime: '创建时间',
      back: '返回'
    }
  }
}